import {useQuery} from "@apollo/client";
import {CheckUserResetToken} from "./UserReset.js";

export function useCheckUserResetToken(params = {}) {
    const {data, previousData, loading, error, refetch, variables} = useQuery(
        CheckUserResetToken,
        {...params, notifyOnNetworkStatusChange: true}
    );
    
    let holder = (data && data['CheckUserResetToken']) ? data : previousData;
    const extracted = (holder) ? holder['CheckUserResetToken'] : null;

    if(error) console.log(error);

    return {
        data: extracted, 
        loading: (loading && !previousData), 
        refetch, 
        variables,
        error: error
                ? <div className="bg-red-600 text-white px-4 py-2 mt-1 rounded-md">{error?.message}</div>
                : null
    }
}
export async function asyncCheckUserResetToken(variables = {}, apolloClient) {
    const {data, loading} = await apolloClient.query({
        query: CheckUserResetToken,
        variables
    });
    const extracted = data ? data['CheckUserResetToken'] : null;
    return {
        data: extracted,
        loading: loading,
        variables
    }
}
